<template>
  <div class="theme-background-pane">
    <div
      v-if="!hasTheme"
      class="theme-background-pane__state alert alert-warning text-center"
      role="alert"
    >
      Theme is not selected. Please select theme
    </div>

    <ExternalContentView
      v-else
      ref="content"
      endpoint="/banner/background-list"
      :page-size="pageSize"
      :extra-params="params"
      :show-search="false"
      :external-preview="true"
      :show-copy-to-file-browser="cropped === '0'"
      @onSelectedItems="(items) => $emit('onSelectedItems', items)"
      @open-preview="(item) => $emit('open-preview', item)"
      @copy-to-file-browser="(item) => $emit('copy-to-file-browser', item)"
    />
  </div>
</template>

<script>
import ExternalContentView from '@frontend/components/modules/file-browser/modals/ExternalContentView.vue';
import externalPaneMixin from '@frontend/components/modules/file-browser/modals/externalPaneMixin';
import { GRID_PAGE_SIZE } from '@frontend/constants/select-image-grid';

export default {
  name: 'ThemeBackgroundPane',
  components: {
    ExternalContentView,
  },
  mixins: [externalPaneMixin],
  props: {
    // Custom-element attributes arrive as strings, so this is '1' / '0' rather than a Boolean.
    cropped: {
      type: String,
      default: '0',
    },
    pageSize: {
      type: Number,
      default: GRID_PAGE_SIZE,
    },
  },
  computed: {
    hasTheme() {
      return Boolean(this.params.theme);
    },
  },
  methods: {
    setParams(next) {
      this.mergeParams({ ...next, cropped: this.cropped });
    },

    // Used after uploading into a theme: the new image lands at the end of the last page.
    selectLast() {
      const content = this.$refs.content;
      const last = content?.items?.[content.items.length - 1];

      if (!last) {
        return false;
      }

      // toggleSelect would deselect it when a previous round trip left the same item selected.
      if (!content.isSelected(last)) {
        content.toggleSelect(last);
      }

      return true;
    },
  },
};
</script>

<style scoped>
.theme-background-pane__state {
  margin: 16px 0;
}
</style>
